import { create } from 'zustand';

import { AddressFormValues } from '../types';

export const initialAddressValues: AddressFormValues = {
  street_number: '',
  address_line_1: '',
  address_line_2: '',
  city: '',
  state_province_region: '',
  zip_postal_code: '',
};

type Store = {
  formState: AddressFormValues;
  setFormValues: (newValues: Partial<AddressFormValues>) => void;
  reset: () => void;
};

// Module-level singleton: StepWizard unmounts inactive steps, so the address
// must outlive the Address screen. `reset` exists for tests and re-entry.
export const useFormState = create<Store>()(set => ({
  formState: initialAddressValues,
  setFormValues: newValues => {
    return set(state => {
      return { ...state, formState: { ...state.formState, ...newValues } };
    });
  },
  reset: () => {
    return set({ formState: initialAddressValues });
  },
}));
